// Port of api/fuel/app/classes/controller/api/monty/views/manage.php
import DB from 'offline/db'

function viewToArray(row) {
	var fields = row.view_fields || []
	if (typeof fields === 'string') {
		try { fields = JSON.parse(fields) } catch (e) { fields = [] }
	}
	return {
		id: parseInt(row.view_id, 10) || 0,
		default: parseInt(row.view_default, 10) || 0,
		type: parseInt(row.view_type, 10) || 0,
		context: parseInt(row.view_context, 10) || 0,
		public: parseInt(row.view_public, 10) || 0,
		name: row.view_name,
		fields: fields
	}
}

export default function(params) {
	var userId = params.sessionUserId || DB.meta('sync_user_id')
	var views = userId ? DB.query('SELECT * FROM view WHERE user_id = ?', [userId]) : []
	return Promise.resolve({ session: { offline: true }, data: { views: views.map(viewToArray) } })
}
